import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function get(customConfig?: AxiosRequestConfig): Promise<AxiosResponse<string[]>> {
    return client.get('/opportunities', customConfig);
}

export function post(payload: unknown, customConfig?: AxiosRequestConfig) {
    return client.post('opportunities', payload, customConfig);
}

export function get_preconsultation_clients(
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<string[]>> {
    return client.get('/preapplication_users', customConfig);
}
